module.exports = __webpack_public_path__ + "static/media/welcome3.547d7d30.jpg";